<template>
  <v-row >
<!--dialogextra columns-->
<v-col cols-12 md-6>
    <v-sheet class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('food_composition')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <h2 class="text-regularlight" >Food</h2>

  
</v-col>
<!--end extra columns-->

  <!--end of first column-->
    <v-col  cols-12 md-6 style="min-width: 300px; max-width: 350px">
      <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1 d-flex flex-wrap">
      <div v-for="col in meta.columns" :key="col">
        <h4 class="text-regular"> 
          <base-geo-cell v-if = "col.fieldname === 'store_species'" v-bind="{mode:'view', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </h4>
      </div>
      </v-sheet>

      <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1 d-flex flex-wrap">
      <span>Leg.Number:</span>&nbsp; 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'leg_number'" v-bind="{mode:'view', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      </v-sheet>

      <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1 d-flex flex-wrap">
      <span>Collection:</span>&nbsp; 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'main_storage'" v-bind="{mode:'view', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      </v-sheet>


      <v-sheet style="min-width: 300px; max-width: 100%;" class="my-1 d-flex flex-wrap">
      <span>LID:</span>&nbsp; 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'lid'" v-bind="{mode:'table', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      </v-sheet>

      
    </v-col>
  </v-row>

</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StandardBaseFormT',
    components: {

},

data(){ 
    return {

    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {
  // col in meta.columns
  handleDate (value) {
    this.curentRow.leg_date = value;
  },


},

computed: {

getColumn() {



},
},

  mounted(){

  },

})
</script>